import { FETCH_ALERT_HISTORY_SUCCESS } from "../action/alert.action";

const initialState = {
  history: [],
};

export default function alertReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_ALERT_HISTORY_SUCCESS:
      return {
        ...state,
        history: action.payload
      };
    default:
      return state;
  }
}